import React, { useState,useEffect } from "react";
import Header from './Header/Header';
import Footer from './footer/Footer';

const PageWrapper = (props) => {
  const [state, setState] = useState({
    collapsed: false
  });

  return (
    <>
      <div className="maincontainer">
        <Header title={props.title}></Header>
        {props.children}
        <Footer/>
        </div>
      {/* {} */}
    </>
  );
};

export default PageWrapper;
